// Email/password login (no signup — accounts are provisioned in Supabase).
// On success, App's auth subscription re-reads the session and unmounts this.

import { type CSSProperties, useState } from "react";

import { signIn } from "../auth/session";
import { useT } from "../lib/i18n";
import { LangToggle } from "./LangToggle";

export function LoginView() {
  const t = useT();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(username.trim(), password);
      // onAuthChange in App takes over from here.
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  }

  return (
    <section className="starter">
      <form className="starter-card" style={card} onSubmit={submit}>
        <div style={{ alignSelf: "flex-end" }}>
          <LangToggle />
        </div>
        <h1>{t("app.brand")}</h1>
        <p className="starter-desc">{t("login.subtitle")}</p>
        <label className="control" style={{ width: "100%" }}>
          <span className="control-label">{t("login.username")}</span>
          <input
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <label className="control" style={{ width: "100%" }}>
          <span className="control-label">{t("login.password")}</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <button
          className="btn btn-primary btn-lg"
          style={{ width: "100%", marginTop: 8 }}
          disabled={busy || !username || !password}
        >
          {busy ? t("login.signingIn") : t("login.signIn")}
        </button>
        {error && (
          <p className="upload-status error" style={{ marginTop: 4 }}>
            {error}
          </p>
        )}
      </form>
    </section>
  );
}

const card: CSSProperties = {
  maxWidth: 380,
  display: "flex",
  flexDirection: "column",
  gap: 12,
};
